import { ApiClient } from '@solar/api-client';

/**
 * 앱 전체가 공유하는 단일 클라이언트.
 *
 * 인스턴스를 하나로 두는 이유는 `refreshOnce()` 때문이다. 클라이언트가
 * 여러 개면 각자 refresh 토큰을 회전시켜 서로를 무효화한다.
 */
export const api = new ApiClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  onUnauthorized: () => {
    window.dispatchEvent(new CustomEvent('solar:unauthorized'));
  },
});

/** 현장 사진 슬롯. 레거시 `build_order.image1~image17` 의 실사용 7개. */
export const PHOTO_SLOTS: Array<{ slot: number; label: string; required: boolean }> = [
  { slot: 1, label: '설치 전', required: true },
  { slot: 2, label: '설치 후', required: true },
  { slot: 3, label: '전력량계', required: true },
  { slot: 4, label: '명판', required: true },
  { slot: 5, label: '주민등록초본', required: false },
  { slot: 6, label: '영수증', required: false },
  { slot: 7, label: '추가 서류', required: false },
];
